import styled from 'styled-components';

export const CloseButton = styled.button`
  background: #000;
  border: 0;
  cursor: pointer;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    fill: #fff;
  }
`;
